import {
    AppBar,
    Box,
    Button,
    type SxProps,
    type Theme,
    Toolbar,
    styled,
    useResolution,
} from '@lingoda/ui';
import { LingodaLogo } from '@lingoda/logotype';
import { trans } from '@lingoda/i18n';
import { CaretLeftIcon } from '@lingoda/ui/icons/lingodaIcons';
import type { PropsWithChildren, ReactNode } from 'react';

interface StepperProps {
    stepperChildrenSx?: SxProps<Theme>;
    handleSkip?: () => void;
    handleBack?: () => void;
    progressBar?: ReactNode;
}

export const Stepper = ({
    children,
    stepperChildrenSx,
    handleSkip,
    handleBack,
    progressBar,
}: PropsWithChildren<StepperProps>) => {
    const isPhone = useResolution('phone');

    return (
        <StyledWrapper>
            <AppBar elevation={1} position="static" color="inherit">
                <Toolbar>
                    <Box display="flex" justifyContent="space-between" width="100%">
                        <Box display="flex" alignItems="center">
                            <Box sx={{ width: 135 }}>
                                <LingodaLogo />
                            </Box>
                        </Box>
                        {handleSkip && (
                            <Button variant="text" onClick={handleSkip}>
                                {trans('skip', {}, 'student-onboarding')}
                            </Button>
                        )}
                    </Box>
                </Toolbar>
            </AppBar>
            <Box sx={{ mt: isPhone ? 0 : 3, mb: isPhone ? 4 : 3 }}>
                <Box display="flex" justifyContent="center" alignItems="center">
                    {!isPhone && handleBack && (
                        <Box mr={1}>
                            <Button
                                startIcon={<CaretLeftIcon size={24} />}
                                onClick={handleBack}
                                size="small"
                            >
                                {trans('go-back', {}, 'public-common')}
                            </Button>
                        </Box>
                    )}
                    {progressBar}
                </Box>
            </Box>
            <StyledChildren sx={stepperChildrenSx}>{children}</StyledChildren>
        </StyledWrapper>
    );
};

const StyledWrapper = styled(Box)(() => ({
    height: '100%',
    width: '100%',
    maxHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
}));

const StyledChildren = styled(Box)(({ theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(0, 2, 15),
    flexGrow: 1,
}));
